<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EZpxBA/tc-custom/9781595586124.jpg?1726519109856" alt="This image is the cover for the book Fifth Woman, The Kurt Wallander Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fifth Woman, The Kurt Wallander Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>From the #1 international-bestselling master of Scandinavian noir: a “marvelously told mystery” of murder in Sweden and corruption in Africa (<i>Austin American-Statesman</i>).</b><br/>  <br/> In an African convent, four nuns and an unidentified fifth woman are found with their throats slit. The local police do little to investigate . . . and cover up the unknown woman’s death. A year later in Sweden, Holger Eriksson, a retired car dealer and birdwatcher, is skewered to death after falling into a pit of carefully sharpened bamboo poles. Soon after, the body of a missing florist is discovered strangled and tied to a tree. Baffled and appalled by the crimes, the only clues Inspector Kurt Wallander has to go on are a skull, a diary, and a photo of three men.<br/>  <br/> What ensues is a complex, meticulously plotted investigation that will push the detective to his limits. The key is the unsolved killing of the fifth woman in Africa—who was she, and what did she have to do with the brutal deaths of two seemingly innocent men? Are more victims in danger? The answers will lead Wallander to question everything he thought he knew about the psychology of murder.<br/>  <br/> An international bestseller, this “scary and cunning tale” (<i>Rocky Mountain News</i>) “achieves the satisfying density of plot and characterization” that established Henning Mankell as one of the twentieth-century’s finest crime writers. His Kurt Wallander mysteries are now the basis for the hit TV show <i>Wallander </i>starring Kenneth Branagh (<i>The Baltimore Sun</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henning Mankell, Steven T. Murray
      </h2>
      
      <p class="authorDescription body article">Henning Mankell&#39;s Kurt Wallander mysteries are global bestsellers and have been adapted for television as a BAFTA Award&ndash;winning BBC series starring Kenneth Branagh. Mankell was awarded the Crime Writers&rsquo; Association&rsquo;s Macallan Gold Dagger and the German Tolerance Prize, among many others. He divides his time between Sweden and Mozambique.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Press, The
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13017788